import {
    FETCH_ADDED_LINE_SUCCESS,
    FETCH_TITLE_SUCCESS,
    FETCH_LINE_SUCCESS,
    FETCH_TAGS_SUCCESS,
    FETCH_COMMENTS_SUCCESS,
    FETCH_USER_SUCCESS,
    ADD_NOTIFIC_COMMENTS_IDS_SUCCESS,
    EDIT_FAVICON_SUCCESS,
    FETCH_COMMENTS_TIME_SUCCESS,
    FETCH_LINE_UPDATE_TIME_SUCCESS,
    FETCH_SAVED_LISTS_SUCCESS,
    ADD_SAVED_LISTS_NOTIFICATION_SUCCESS,
    ADD_SAVED_LISTS_NOTIFICATION_START
} from '../actionTypes'
import database from '../actions/database'
import { fetchComments, editUserCommentTime, editUserHistoryTime, fetchHistory } from '../actions'
import {  conditionCommentsTime, conditionLineUpdateTime, conditionHistoryTime } from '../functions/snippets'
import {snapshotToArray} from "../selectors";
import favicons from '../data/favicons'

export const watchLines = (key, faviconNotific) => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/lines')
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        //payload && dispatch({type: FETCH_ADDED_LINE_SUCCESS, payload});
        dispatch({type: FETCH_ADDED_LINE_SUCCESS, payload});
        faviconNotific()
    });

    rootRef.orderByChild('date').limitToLast(1).on('value', snapshot => {
        const payload = snapshot.val();
    });
}

export const watchNotificationSavedList = (lists, userId) => (dispatch, getState) => {

    dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_START});

    lists.forEach(async (item) => {
        console.log('item', item);

        database.ref().child('/data/'+item.id + '/history').on('value', async snap => {
            let user = await database.ref().child('/data/'+item.id + '/users/'+userId).once('value')
            const id = getState().keyList;
            user = user.val()
            console.log('user', user)
            let countHistory = conditionHistoryTime(snapshotToArray(snap.val()), user)
            if(id !== item.id){
                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{tempId:id, id: item.id,  data: {countHistory}}});
            }
        });
    });



    /*let listNotific = {}
    lists.forEach(async (item) => {
        let list = await database.ref().child('/data/'+item.id).once('value');
        list = list.val()
        if(list.users && list.users[userId]){
            const user = list.users[userId]
            let countLine = calculateLine(list, user)
            let countComment = calculateComment(list, user)

            countLine + countComment > 0 &&
                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{ id: item.id,  data: {countLine, countComment}}});

            const updateTimeCommentRef = database.ref().child('/data/'+item.id+'/commentsTime')
            const updateTimeLineRef= database.ref().child('/data/'+item.id+'/lines')

            const updateTimeUserCommentRef = database.ref().child('/data/'+item.id+'/users/'+ userId + '/commentsTime')
            const updateTimeUserLineRef = database.ref().child('/data/'+item.id+'/users/'+ userId + '/lineUpdateTime')

            updateTimeCommentRef.on('value', snapshot => {
                const payload = snapshot.val();
                let listTemp = {...list, commentsTime: payload}
                let countComment = calculateComment(listTemp, user)


                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{ id: item.id,  data: {countComment}}});
            });

            updateTimeLineRef.on('value', snapshot => {
                const payload = snapshot.val();
                let listTemp = {...list, lines: payload}
                let countLine = calculateLine(listTemp, user)


                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{ id: item.id,  data: {countLine}}});
            });

            updateTimeUserCommentRef.on('value', snapshot => {
                const payload = snapshot.val();
                let userTemp = {...user, commentsTime: payload}
                let countComment = calculateComment(list, userTemp)

                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{ id: item.id,  data: {countComment}}});
            });

            updateTimeUserLineRef.on('value', snapshot => {
                const payload = snapshot.val();
                let userTemp = {...user, lineUpdateTime: payload}
                let countLine = calculateLine(list, userTemp)


                dispatch({type: ADD_SAVED_LISTS_NOTIFICATION_SUCCESS, payload:{ id: item.id,  data: {countLine}}});
            });
        }

    })





    function calculateLine (list, user) {
        let alertCount = 0;
        let cond;
        snapshotToArray(list.lines).forEach((item, index) => {
            cond = conditionLineUpdateTime(item.date, user.lineUpdateTime, item.id, user.id, item.userUpdate)
            cond && alertCount ++
        })

        return alertCount
    }

    function calculateComment (list, user) {
        let alertCount = 0;
        let cond;
        snapshotToArray(list.lines).forEach((item, index) => {
            cond = list.commentsTime && conditionCommentsTime(list.commentsTime, user.commentsTime, item.id)
            cond && alertCount ++
        })

        return alertCount
    }*/

}

export const watchTags = key => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/tags')
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        dispatch({type: FETCH_TAGS_SUCCESS, payload});

    });
}

export const watchTitle = key => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/title')
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        payload && dispatch({type: FETCH_TITLE_SUCCESS, payload});
    });
}

export const watchComments = key => (dispatch, getState) => {
    const rootRef = database.ref().child('/data/'+key+'/comments')
    rootRef.orderByChild('date').startAt(Date.now()).on('child_added', snapshot => {
        const line = getState().openComments.line;
        const openCommentId = getState().openComments.line.id;
        const keyLine = line.id ? line.id : ' ';
        const user = getState().user

        if(openCommentId == snapshot.val().keyLine){
            const oldDate = user.commentsTime[keyLine].oldDate
            editUserCommentTime(key, user.id, keyLine, oldDate)
        }
        fetchComments(key, keyLine, user)(dispatch);
    });

}

export const watchHistory = key => (dispatch, getState) => {
    const rootRef =  database.ref('/data/' + key + '/history');
    rootRef.on('value', snapshot => {
        const isOpen = getState().dropBox.history;
        const user = getState().user;

        if(isOpen){
            const oldDate = user.historyTime.oldDate;
            editUserHistoryTime(key, user.id, oldDate)
        }
        fetchHistory(key, user)(dispatch);
    });
}

export const watchUser = (key, userId) => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/users/'+userId)
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        payload && dispatch({type: FETCH_USER_SUCCESS, payload});
        const users = JSON.parse(localStorage.getItem('users')) ? JSON.parse(localStorage.getItem('users')) : {}
        users[key] = payload
        localStorage.setItem('users', JSON.stringify(users))
    });
}

export const addUserStorage = (key, user) => {
    const users = JSON.parse(localStorage.getItem('users')) ? JSON.parse(localStorage.getItem('users')) : {}
    users[key + 'temp'] = user
    localStorage.setItem('users', JSON.stringify(users))
}

export const watchCommentsTime = key => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/commentsTime')
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        payload && dispatch({type: FETCH_COMMENTS_TIME_SUCCESS, payload});
    });
}

export const watchLineUpdateTime = key => dispatch => {
    const rootRef = database.ref().child('/data/'+key+'/lineUpdateTime')
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        payload && dispatch({type: FETCH_LINE_UPDATE_TIME_SUCCESS, payload});
    });
}

export const watchSavedLists = idUser => dispatch => {
    const rootRef =  database.ref('/authUsers/' + idUser + '/lists/');
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        payload && dispatch({type: FETCH_SAVED_LISTS_SUCCESS, payload});
    });
}


/*

export const watchLine = (key, lineKey) => dispatch => {
    /!*const rootRef = database.ref().child_changed('/data/'+key+'/lines');
    rootRef.on('value', snapshot => {
        const payload = snapshot.val();
        console.log(payload)
        //payload && dispatch({type: FETCH_LINE_SUCCESS, payload});
    });*!/
}*/



// WEBPACK FOOTER //
// ./src/actions/firebaseWatch.js